var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinearCheckboxShowLess = function SvgLinearCheckboxShowLess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 7093",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.56,
    height: 23.559
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 195",
    fill: "none",
    d: "M0 0h23.559v23.559H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4143",
    transform: "translate(3.927 3.927)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 196",
    width: 15.706,
    height: 15.706,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 41",
    d: "M11.78 7.853H3.927"
  }))));
};
export { SvgLinearCheckboxShowLess as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iR3JvdXBfNzA5MyIgZGF0YS1uYW1lPSJHcm91cCA3MDkzIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMy41NiIgaGVpZ2h0PSIyMy41NTkiIHZpZXdCb3g9IjAgMCAyMy41NiAyMy41NTkiPgogIDxyZWN0IGlkPSJSZWN0YW5nbGVfMTk1IiBkYXRhLW5hbWU9IlJlY3RhbmdsZSAxOTUiIHdpZHRoPSIyMy41NTkiIGhlaWdodD0iMjMuNTU5IiBmaWxsPSJub25lIi8+CiAgPGcgaWQ9Ikdyb3VwXzQxNDMiIGRhdGEtbmFtZT0iR3JvdXAgNDE0MyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMy45MjcgMy45MjcpIj4KICAgIDxyZWN0IGlkPSJSZWN0YW5nbGVfMTk2IiBkYXRhLW5hbWU9IlJlY3RhbmdsZSAxOTYiIHdpZHRoPSIxNS43MDYiIGhlaWdodD0iMTUuNzA2IiByeD0iMiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KICAgIDxsaW5lIGlkPSJMaW5lXzQxIiBkYXRhLW5hbWU9IkxpbmUgNDEiIHgxPSI3Ljg1MyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMy45MjcgNy44NTMpIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjEuNSIvPgogIDwvZz4KPC9zdmc+Cg==";